import { ModalState } from 'models/modal';

import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export const initialState: ModalState = {
  isVisible: false,
  actionType: null,
  modalProps: {},
};

export const slice = createSlice({
  name: 'modal',
  initialState,
  reducers: {
    setModal: (state, { payload }: PayloadAction<{ actionType: string; props?: { [key: string]: any } }>) => {
      state.isVisible = true;
      state.actionType = payload.actionType;
      state.modalProps = payload.props;
    },
    closeModal: (state) => {
      state.isVisible = false;
      state.actionType = null;
      state.modalProps = {};
    },
  },
});

export default slice.reducer;
